import React, { useContext } from 'react';

import { BlockSerializerUbiContext } from 'lib/sanity/ui/BlockSerializerUbiProvider';
import { ArticleLink } from 'components/Links';
import { InternalLinkMarkDef } from 'lib/sanity/types';

interface ArticleInternalLinkProps {
  mark: InternalLinkMarkDef;
  children: React.ReactNode;
}

const ArticleInternalLink = ({ mark, children }: ArticleInternalLinkProps) => {
  const ubi = useContext(BlockSerializerUbiContext);
  return (
    <ArticleLink slug={mark.slug} ubiFactory={ubi.logArticleLink((mark as InternalLinkMarkDef).slug)}>
      {children}
    </ArticleLink>
  );
};
export default ArticleInternalLink;
